/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for emissions data grouped by provider.
 * @export
 * @interface ProviderEmissions
 */
export interface ProviderEmissions {
    /**
     * 
     * @type {string}
     * @memberof ProviderEmissions
     */
    dataProvider: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderEmissions
     */
    dataProviderName: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderEmissions
     */
    secondaryDataSource: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProviderEmissions
     */
    totalEmissions: number;
    /**
     * 
     * @type {number}
     * @memberof ProviderEmissions
     */
    count: number;
}

/**
 * Check if a given object implements the ProviderEmissions interface.
 */
export function instanceOfProviderEmissions(value: object): value is ProviderEmissions {
    if ((!('dataProvider' in (value as Record<string, any>)) && !('data_provider' in (value as Record<string, any>))) || ((value as Record<string, any>)['dataProvider'] === undefined && (value as Record<string, any>)['data_provider'] === undefined)) return false;
    if ((!('dataProviderName' in (value as Record<string, any>)) && !('data_provider_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['dataProviderName'] === undefined && (value as Record<string, any>)['data_provider_name'] === undefined)) return false;
    if ((!('secondaryDataSource' in (value as Record<string, any>)) && !('secondary_data_source' in (value as Record<string, any>))) || ((value as Record<string, any>)['secondaryDataSource'] === undefined && (value as Record<string, any>)['secondary_data_source'] === undefined)) return false;
    if ((!('totalEmissions' in (value as Record<string, any>)) && !('total_emissions' in (value as Record<string, any>))) || ((value as Record<string, any>)['totalEmissions'] === undefined && (value as Record<string, any>)['total_emissions'] === undefined)) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function ProviderEmissionsFromJSON(json: any): ProviderEmissions {
    return ProviderEmissionsFromJSONTyped(json, false);
}

export function ProviderEmissionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderEmissions {
    if (json == null) {
        return json;
    }
    return {
        
        'dataProvider': json['data_provider'],
        'dataProviderName': json['data_provider_name'],
        'secondaryDataSource': json['secondary_data_source'],
        'totalEmissions': json['total_emissions'],
        'count': json['count'],
    };
}

export function ProviderEmissionsToJSON(json: any): ProviderEmissions {
    return ProviderEmissionsToJSONTyped(json, false);
}

export function ProviderEmissionsToJSONTyped(value?: ProviderEmissions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data_provider': value['dataProvider'],
        'data_provider_name': value['dataProviderName'],
        'secondary_data_source': value['secondaryDataSource'],
        'total_emissions': value['totalEmissions'],
        'count': value['count'],
    };
}

